import { formatISO } from 'date-fns';

export const dateToString = (value: Date | null): string => {
  if (value) {
    const strValue = value.toString();
    return strValue !== 'Invalid Date' ? formatISO(new Date(value)) : strValue;
  }
  return '';
};
